/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Reverse_Three_SecondsInputs */



/**
* | output |
* | --- |
* | "Go back three second in the video" |
*
* @param {Shortcut_Keys_Desc_Reverse_Three_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_reverse_three_seconds = /** @type {((inputs?: Shortcut_Keys_Desc_Reverse_Three_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Reverse_Three_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reculer de trois secondes dans la video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Spule im Video drei Sekunden zurück.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Torna indietro di tre secondi nel video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вернитесь на три секунды назад в видео.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Retroceda tres segundos en el vídeo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频倒回三秒处。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("動画を3秒前に戻します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो में तीन सेकंड पीछे जाइए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Volte três segundos no vídeo.")
	return /** @type {LocalizedString} */ ("Go back three second in the video")
});